function ThirdPillarApplication() {
  const renderer = require('Renderer')
  let thirdPillarApplication

  this.init = function () {
    thirdPillarApplication = JSON.parse(sessionStorage.getItem('thirdPillarApplication'))
    if (!thirdPillarApplication) {
      location.href = '#third-pillar-select'
    }

    new UpdateContactInfo(session.customer, renderApplication).init()
    return {}
  }

  this.done = function () {
    function submit(e) {
      e.preventDefault()

      function onApplicationSent(signedDocument) {
        sessionStorage.removeItem('thirdPillarApplication')
        location.href = '#thirdpillarsuccess' +
          '?signedDocumentId=' + signedDocument['signedDocumentId'] +
          '&applicationId=' + signedDocument['applicationId']
      }

      function onSigned(signedDocument) {
        sendApplication(signedDocument).then(() => onApplicationSent(signedDocument))
      }

      new Signer(session.authType, prepare, onSigned).sign()
    }

    $('#submit').click(submit)
    $('#consent').click(function () {
      if ($(this).is(':checked')) $('#submit').removeAttr('disabled')
      else $('#submit').attr('disabled', 'disabled')
    })

    renderApplication()
  }

  function renderApplication() {
    $('#third-pillar-application-content').html(renderer.template('third-pillar-application')({
      customer: session.customer,
      hasDistributionRows: thirdPillarApplication.distributionRows.length > 0,
      distributionRows: thirdPillarApplication.distributionRows.map(row => ({
        to: Funds.thirdPillar[row.to].name,
        from: Funds.thirdPillar[row.from].name,
        fundPercentage: row.percentage,
        units: row.units
      })),
      newFunds: thirdPillarApplication.newFunds.map(fund => ({name: fund.name, fundPercentage: fund.percentage}))
    }))
  }

  function prepare() {
    $('#technical-error').text('').addClass('d-none')
    const data = {
      distributionRows: JSON.stringify(thirdPillarApplication.distributionRows),
      newFunds: JSON.stringify(thirdPillarApplication.newFunds)
    }
    return $.post('/application/third-pillar/prepare', data)
      .fail(function (xhr) {
        Logger.error('Application error: ' + xhr.responseText);
        $('#technical-error').text(xhr.responseText).removeClass('d-none')
      })
  }

  function sendApplication(signedDocument) {
    return $.post('/application/third-pillar/send-application', signedDocument)
      .fail(function (xhr) {
        Logger.error('Application  : ' + xhr.responseText);
      })
  }
}
